import React from 'react';
import { CtaButton } from './ui/CtaButton';
export function CostOfInaction() {
  return <section className="py-16 px-4 bg-zinc-900/20 border-y border-zinc-900" data-id="element-176">
      <div className="max-w-4xl mx-auto" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center text-white" data-id="element-178">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="bg-zinc-950 border border-zinc-800 rounded-3xl overflow-hidden" data-id="element-179">
          <div className="grid grid-cols-2 border-b border-zinc-800 bg-zinc-900/50" data-id="element-180">
            <div className="p-6 font-bold text-zinc-400" data-id="element-181">SIN MEGAPACK</div>
            <div className="p-6 font-bold text-red-400" data-id="element-182">COSTO REAL</div>
          </div>

          <div className="divide-y divide-zinc-800/50" data-id="element-183">
            {[['Inventar actividades desde cero', 'Energía mental agotada cada día'], ['Ceder el celular con culpa', 'Más tiempo de pantalla + culpa'], ['Comprar cosas que duran 2 días', 'Dinero perdido'], ['Días de lluvia sin plan', 'Estrés + pantalla todo el día'], ['Sin sistema de hábitos', 'El mismo ciclo mañana']].map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-zinc-900/30 transition-colors" data-id="element-184">
                <div className="p-6 text-zinc-300" data-id="element-185">{row[0]}</div>
                <div className="p-6 text-zinc-500" data-id="element-186">{row[1]}</div>
              </div>)}
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-187">
          <p className="text-2xl font-bold text-cyan-400 mb-6" data-id="element-188">
            "Tu hijo entretenido. Vos con tu café caliente." ☕
          </p>
          <CtaButton label="EMPEZAR HOY" size="xl" data-id="element-189" />
        </div>
      </div>
    </section>;
}